import { Navigate } from 'react-router-dom';

export default function EntitlementRedirect({ products }) {
  if (!products || products.length === 0) return null; // still loading
  // Default: go to core if available, otherwise first product
  const defaultProduct = products.includes('core') ? 'core' : products[0];
  const routes = { core: '/app/core', re_suite: '/app/re-suite' };
  return <Navigate to={routes[defaultProduct] || '/app/core'} replace />;
}
